import { Fragment } from 'react';

import { PAYERS_FILTER_PAYER_TYPES, PAYERS_FILTER_TYPES, PAYERS_FILTER_TYPES_INT } from 'utils/constants/payer';

import Button, { ButtonKind } from 'bloko/blocks/button';
import Checkbox from 'bloko/blocks/checkbox';
import { FormItem, FormSpacer } from 'bloko/blocks/form';
import Gap from 'bloko/blocks/gap';
import InputText, { InputType } from 'bloko/blocks/inputText';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import AdminFilterWrapper from 'components/Filter';

import fetchPayers from 'components/Admin/Payers/Filter/fetchPayers';

import {
    PayerFilterType,
    setFilterPayerType,
    setFilterType,
    setFilterValue,
    setFilterWithoutAgreement,
} from 'store/models/payers';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/Payers/Filter/Filter.less';

const Filter = () => {
    const { filterType, filterValue, filterPayerType, filterWithoutAgreement } = useSelector((state) => state.payers);
    const dispatch = useDispatch();
    const trl = useTrls();

    const isKeyEnter = (event) => {
        if (event.key === 'Enter') {
            dispatch(fetchPayers());
        }
    };

    return (
        <AdminFilterWrapper
            settings={
                <Fragment>
                    <Select
                        value={filterType}
                        onChange={({ target }) => dispatch([setFilterType(target.value), setFilterValue('')])}
                        data-qa="select-search-by"
                    >
                        {PAYERS_FILTER_TYPES.map((value) => (
                            <Option key={value} value={value}>
                                {trl(`admin.Payers.Filter.FilterType.${value}`)}
                            </Option>
                        ))}
                    </Select>
                    <FormSpacer>
                        <InputText
                            type={PAYERS_FILTER_TYPES_INT.includes(filterType) ? InputType.Number : InputType.Text}
                            value={filterValue}
                            onChange={(value) => dispatch(setFilterValue(value))}
                            size="30"
                            placeholder={trl('admin.Payers.Filter.FilterValue')}
                            onKeyDown={isKeyEnter}
                            data-qa="search-field"
                        />
                    </FormSpacer>
                    <Gap left />
                    <Select
                        value={filterPayerType}
                        onChange={({ target }) => dispatch(setFilterPayerType(target.value))}
                    >
                        <Option key={PayerFilterType.Empty} value="">
                            {trl(`admin.Payers.Filter.PayerType.${PayerFilterType.Empty}`)}
                        </Option>
                        {PAYERS_FILTER_PAYER_TYPES.map((value) => (
                            <Option key={value} value={value}>
                                {trl(`admin.Payers.Filter.PayerType.${value}`)}
                            </Option>
                        ))}
                    </Select>
                    <Gap left />
                    <div className="payers-filter-checkbox">
                        <FormItem baseline>
                            <Checkbox
                                onChange={() => dispatch(setFilterWithoutAgreement(!filterWithoutAgreement))}
                                checked={filterWithoutAgreement}
                            >
                                {trl('admin.Payers.Payer.not.agreement')}
                            </Checkbox>
                        </FormItem>
                    </div>
                </Fragment>
            }
            actions={
                <Button kind={ButtonKind.Primary} onClick={() => dispatch(fetchPayers())}>
                    {trl('admin.Payers.Filter.find')}
                </Button>
            }
        />
    );
};

export default Filter;
